import React from "react";

import Typograf from "typograf";

const VtrgText = ({ data, slot }) => {
  const {
    back_color: background,
    text_color: color,
    inverted,
    body: content,
  } = data || {};

  const tp = new Typograf({ locale: ["ru", "en-US"] });

  return (
    <div data-slot={slot} className={inverted === 1 ? "inverted" : ""}>
      <div
        className="holder"
        style={
          inverted === 2
            ? {
                backgroundColor: `${background ? background : "#fff"}`,
                color: `${color ? color : "#000"}`,
              }
            : {}
        }
      >
        <div
          className="content"
          dangerouslySetInnerHTML={{ __html: tp.execute(!!content && content) }}
        ></div>
      </div>
    </div>
  );
};

export default VtrgText;
